import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMetaPixel } from '@/hooks/useMetaPixel';

interface MetaPixelTrackerProps {
    pixelId?: string;
    enabled?: boolean;
}

const MetaPixelTracker: React.FC<MetaPixelTrackerProps> = ({ 
    pixelId, 
    enabled = true 
}) => {
    const location = useLocation(); // Safe to use here as it's within BrowserRouter
    const settingsData = useSelector((state: any) => state.settingsList?.data?.settingsData);
    
    // Parse Meta Pixel settings from API response
    let metaPixelId = '';
    let metaPixelEnabled = false;

    if (settingsData?.meta_pixel?.settings) {
        try {
            const settings = JSON.parse(settingsData.meta_pixel.settings);
            metaPixelId = settings.meta_pixel_id || '';
            metaPixelEnabled = settings.meta_pixel_enabled || false;
        } catch (error) {
            console.error('Error parsing Meta Pixel settings in tracker:', error);
        }
    }

    // Use API data if available, otherwise fall back to props
    const finalPixelId = metaPixelId || pixelId;
    const finalEnabled = metaPixelEnabled && enabled;

    const { trackPageView, isAvailable } = useMetaPixel({
        pixelId: finalPixelId,
        enabled: finalEnabled,
        autoTrackPageView: false // Manual page view tracking here
    });

    useEffect(() => {
        if (isAvailable && finalPixelId) {
            trackPageView();
        }
    }, [location.pathname, isAvailable, trackPageView, finalPixelId]);

    return null; // This component does not render any UI
};

export default MetaPixelTracker; 